import apiEndPoints from "../../apiconstants";
import { api, handleErrorResponse } from "../api";

export const actionsApiSlice = api.injectEndpoints({
    endpoints: builder => ({
        createAction: builder.mutation<any, any>({
            query: ({ payLoad }) => ({
                url: `${apiEndPoints?.updateAction}`,
                method: 'POST',
                body: payLoad
            }),
            transformErrorResponse: handleErrorResponse,
        }),
        updateAction: builder.mutation<any, any>({
            query: ({ payLoad, source_id }) => ({
                url: `${apiEndPoints?.updateAction}/${source_id}`,
                method: 'PATCH',
                body: payLoad
            }),
            transformErrorResponse: handleErrorResponse,
        }),
        deleteAction: builder.mutation<any, string>({
            query: (source_id) => ({
                url: `${apiEndPoints?.updateAction}/${source_id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: handleErrorResponse,
        }),
        getIntegrationEndpoints: builder.query<void, void>({
            query: () => ({
                url: `${apiEndPoints?.actionIntegrations}/endpoints`,
                method: 'GET'
            }),
            transformErrorResponse: handleErrorResponse,
            transformResponse: (response: any) => response.data,
        }),
        uploadInternalAction: builder.mutation<any, any>({
            query: (payLoad) => ({
                url: `${apiEndPoints?.actionIntegrations}`,
                method: 'POST',
                body: payLoad
            }),
            transformErrorResponse: handleErrorResponse,
            transformResponse: (response: any) => response.data,
        }),
        actionUploadInternalAction: builder.mutation<any, any>({
            query: (payLoad) => ({
                url: `${apiEndPoints?.actionIntegrations}`,
                method: 'POST',
                body: payLoad
            }),
            transformErrorResponse: handleErrorResponse,
        }),
        postExplainerTraceAndReasoning: builder.mutation<any, any>({
            query: ({ payload, messageId }) => ({
                url: `${apiEndPoints?.postExplainerTraceAndReasoning}/${messageId}`,
                method: 'POST',
                body: payload
            }),
            transformErrorResponse: handleErrorResponse,
            transformResponse: (response: any) => response.data,
        }),
    })
});

export const { useCreateActionMutation, useUpdateActionMutation, useDeleteActionMutation, useGetIntegrationEndpointsQuery, useUploadInternalActionMutation, useActionUploadInternalActionMutation, usePostExplainerTraceAndReasoningMutation } = actionsApiSlice